/**
 * Styled Components - Created by gustavomedina on 05/06/18.
 */
import styled from 'styled-components'
import { Container as ContainerReviews } from '../../components/YotpoReviews/styledComponents'

export const Container = styled(ContainerReviews)`
  padding: 27px 0;
  background-color: #fff;
  margin: 0 auto;
  padding: 40px;
  max-width: 1440px;
  min-height: 80vh;
  display: flex;
  flex-flow: column;
  .yotpo-head {
    display: block !important;
    margin-block: 20px 42px !important;
  }
  .yotpo-headline {
    font: 700 26px / 20px var(--font-barlow-semi-condensed) !important;
    text-transform: uppercase;
  }
  .yotpo-main-widget .yotpo-reviews-wrapper .yotpo-powered-by {
    margin-bottom: 10px !important;
  }
  .yotpo-seo-page-tabs button, .yotpo-reviewer-name {
    font-family: var(--font-barlow) !important;
  }
  .yotpo-distribution-row__list-item-button {
    height: 24px !important;
  }
  .glide__slide {
    height: auto !important;
  }
  .reviews-carousel-card-container {
    height: 100% !important;
  }
  .review-product-image {
    width: 128px !important;
    height: 128px !important;
  }
  .review-product {
    height: unset !important;
  }
  .review-content {
    height: fit-content !important;
  }
  .reviews-carousel-card-review-content-container {
    flex: 1 !important;
  }
  animation: fade-in-bottom 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) 1s both;
  @keyframes fade-in-bottom {
    0% {
      transform: translateY(-20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @media (max-width: 767px) {
    padding: 0;
  }
`

export const RewardLogo = styled.div`
  transform: scale(0.65);
  position: absolute;
  right: 50px;
  top: 0;
  @media (max-width: 760px) {
    position: unset;
    margin-top: -24px;
    margin-bottom: -50px;
    transform: scale(0.55);
    order: -1;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Reviews/styledComponents.tsx